import React from 'react'

import { Box, Grid } from '@material-ui/core'

import { MoySkladSyncInfo } from '../../MoySkladSyncInfo'
import { MoySkladAccountForm } from '../../MoySkladAccountForm'
import { MoySkladWebhookPanel } from '../../MoySkladWebhookPanel'
import { MoySkladStatusMapPanel } from '../../MoySkladStatusMapPanel'
import { MoySkladAttribuesPanel } from '../../MoySkladAttribuesPanel'

export const MoySkladSettingsScreen = () =>
  <Box style={{width: 'calc(100vw - 320px)'}}>
    <Grid container direction="column">
      <Grid item lg={7} xl={7}>
        <MoySkladSyncInfo/>
      </Grid>

      <Grid item lg={7} xl={7}>
        <MoySkladAccountForm/>
      </Grid>

      <Grid item lg={7} xl={7}>
        <MoySkladStatusMapPanel/>
      </Grid>

      <Grid item lg={7} xl={7}>
        <MoySkladAttribuesPanel/>
      </Grid>

      <Grid item lg={7} xl={7}>
        <MoySkladWebhookPanel/>
      </Grid>
    </Grid>
  </Box>